import { IGridFlavor } from "../../../interfaces/igrid-flavor.interface";
import { RegularGridFlavor } from "./regular-grid-flavor";

// Currently ContactsGridFlavor is same as RegularGridFlavor apart from rowHeight
export class ContactsGridFlavor extends RegularGridFlavor implements IGridFlavor {

    public supportsLockedGridRows: boolean = false;
    public rowHeightForVirtualScrolling: number = 0;
}
